/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { RiArrowLeftLine } from '@remixicon/react'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { decryptData, encryptData } from '../../../../utils/api/encrypted';
import ApiFunction from '../../../../utils/api/apiFuntions';
import { Spinner } from 'react-bootstrap';
import { setUserData } from '../../../redux/appDataSlice';
import CustomMultiSelect from '../formElements/customMultiSelect';
import CustomSelect from '../formElements/customSelect';
import { Avatar } from '../../../icons/icons';

const Profile = () => {
    const encryptedData = useSelector(state => state?.appData?.userData);
    const userData = decryptData(encryptedData);
    const [loading, setLoading] = useState(false);
    const [profileImage, setProfileImage] = useState(null);
    const [upoadedImg, setUploadedImg] = useState('');
    const [title, setTitle] = useState('');
    const [company, setCompany] = useState('');
    const { post } = ApiFunction();
    const [selectedLanguages, setSelectedLanguages] = useState([]);
    const [selectedIndustry, setSelectedIndustry] = useState(null);
    const [fullname, setFullname] = useState('');
    const [bio, setBio] = useState('');
    const userTokenEncrypted = useSelector(state => state?.appData?.userToken);
    const userToken = decryptData(userTokenEncrypted);
    const languages = useSelector((state) => state.appData?.languages);
    const [industries, setIndustires] = useState([]);
    const [selectedGender, setSelectedGender] = useState(null);
    const [interestsList, setInterestsList] = useState([]);
    const [selectedInterests, setSelectedInterests] = useState([]);
    const [sortedInterestsList, setSortedInterestsList] = useState([]);
    const prevUserIdRef = React.useRef(null);

    const prevSelectedData = useSelector(state => state?.onboading?.interests);

    const data = new FormData();
    data.append('type', 'get_data');
    data.append('table_name', 'interests');

    const dispatch = useDispatch();

    useEffect(() => {
        const getInterestsList = async () => {
            setLoading(true);
            await post('', data)
                .then(response => {
                    if (response) {
                        setInterestsList(response?.data);
                    } else {
                        console.log("the response from server is not correct");
                    }
                })
                .catch(err => {
                    console.log("there is an error in the response =>", err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }

        getInterestsList();
    }, []);

    // Sort interests by text length - shorter text first
    useEffect(() => {
        if (interestsList && interestsList.length > 0) {
            const sorted = [...interestsList].sort((a, b) => {
                const nameA = a.name || '';
                const nameB = b.name || '';
                return nameA.length - nameB.length;
            });
            setSortedInterestsList(sorted);
        }
    }, [interestsList]);

    const handleCheckboxChange = (event, interest) => {
        const isChecked = event.target.checked;

        if (isChecked) {
            // Check if already at max limit (7)
            if (selectedInterests?.length < 7) {
                setSelectedInterests(prev => [...prev, interest]);
            }
        } else {
            setSelectedInterests(prev => prev?.filter(item => item !== interest));
        }
    };

    // Gender options data
    const genderOptions = [
        { id: 1, name: 'Male', value: 'male' },
        { id: 2, name: 'Female', value: 'female' },
        { id: 3, name: 'Other', value: 'other' }
    ];

    const handleLanguageChange = (newSelectedLanguageNames) => {
        setSelectedLanguages(newSelectedLanguageNames);
    };

    const handleIndustryChange = (selectedIndustryItem) => {
        setSelectedIndustry(selectedIndustryItem);
    };

    const handleGenderChange = (selectedGenderItem) => {
        setSelectedGender(selectedGenderItem);
    };

    // Helper function to safely parse JSON strings with escaped quotes
    const safeJsonParse = (jsonString, fallback = []) => {
        if (!jsonString) return fallback;

        try {
            return JSON.parse(jsonString);
        } catch (error) {
            try {
                const fixedString = jsonString.replace(/\\\"/g, '"');
                return JSON.parse(fixedString);
            } catch (secondError) {
                try {
                    const cleanedString = jsonString.replace(/\\/g, '');
                    return JSON.parse(cleanedString);
                } catch (finalError) {
                    console.warn('Could not parse JSON string:', jsonString, finalError);
                    return fallback;
                }
            }
        }
    };

    const fetchUserData = async () => {
        const userData = {
            table_name: 'users',
            type: 'get_data',
            id: userToken
        }

        await post('', userData)
            .then(res => {
                if (res?.data[0]) {
                    const resData = res?.data[0];
                    const dataEncrypt = encryptData(resData);
                    dispatch(setUserData(dataEncrypt));
                }
            })
            .catch(err => {
                console.log("the error is ", err);
            })
            .finally(() => {

            })
    }

    useEffect(() => {
        fetchUserData();
    }, [])

    useEffect(() => {
        const data = {
            'type': 'get_data',
            'table_name': 'industries'
        }

        const getIndustries = async () => {
            await post('', data)
                .then(response => {
                    if (response) {
                        setIndustires(response?.data);
                    }
                })
                .catch(err => {
                    console.log("there is an error fetching the industries", err);
                })
        }

        getIndustries();
    }, [])

    // Set basic user data when userData changes
    useEffect(() => {
        if (userData && userData?.id) {
            console.log("the userData is", userData);

            // Only set these once when component mounts or user changes
            if (fullname === '' || userData?.id !== prevUserIdRef.current) {
                setFullname(userData?.name || '');
                setBio(userData?.about || '');
                setTitle(userData?.designation || '');
                setCompany(userData?.company || '');

                // Handle gender - find the matching gender object from genderOptions
                if (userData?.gender) {
                    const genderObj = genderOptions.find(g =>
                        g.value === userData.gender.toLowerCase() ||
                        g.name.toLowerCase() === userData.gender.toLowerCase()
                    );
                    setSelectedGender(genderObj || null);
                } else {
                    setSelectedGender(null);
                }

                // Use the safe JSON parse function for languages
                const parsedLanguages = safeJsonParse(userData?.languages, []);
                setSelectedLanguages(parsedLanguages);

                // Parse and set interests from userData
                const parsedInterests = safeJsonParse(userData?.interests, []);
                console.log("Parsed interests from userData:", parsedInterests);
                setSelectedInterests(parsedInterests);

                prevUserIdRef.current = userData?.id;
            }
        }
    }, [userData?.id])

    // Separate useEffect for industry to avoid infinite loop
    useEffect(() => {
        if (userData?.industry && industries.length > 0) {
            if (typeof userData.industry === 'string') {
                const industryObj = industries.find(ind =>
                    ind.name === userData.industry ||
                    ind.id === userData.industry
                );
                setSelectedIndustry(industryObj || { name: userData.industry });
            } else {
                setSelectedIndustry(userData.industry);
            }
        } else if (!userData?.industry) {
            setSelectedIndustry(null);
        }
    }, [userData?.industry, industries.length])

    const imageUrlUplad = async (fileData) => {
        const form = new FormData();
        form.append('type', 'upload_data');
        form.append('user_id', userToken);
        form.append('file', fileData);
        setLoading(true);
        await post('', form)
            .then(response => {
                if (response?.result) {
                    setUploadedImg(response?.url);
                }
            })
            .catch(err => {
                console.log("there is an error uploading the image the error is=>", err);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const UpdateProfile = async () => {
        // Validate min 5 interests
        if (selectedInterests.length < 5) {
            alert('Please select at least 5 interests');
            return;
        }

        const data = new FormData();
        data?.append('type', 'update_data');
        data?.append('id', userToken);
        data?.append('table_name', 'users');
        data?.append('about', bio);
        data?.append('name', fullname);
        data?.append('designation', title);
        data?.append('company', company);
        data?.append('gender', selectedGender?.value || '');

        // Add languages to the form data
        if (selectedLanguages && selectedLanguages.length > 0) {
            data?.append('languages', JSON.stringify(selectedLanguages));
        } else {
            data?.append('languages', JSON.stringify([]));
        }

        // Add industry to the form data
        if (selectedIndustry) {
            data?.append('industry', selectedIndustry.name || selectedIndustry);
        } else {
            data?.append('industry', '');
        }

        // Add interests to the form data
        if (selectedInterests && selectedInterests.length > 0) {
            data?.append('interests', JSON.stringify(selectedInterests));
        } else {
            data?.append('interests', JSON.stringify([]));
        }

        if (upoadedImg) {
            data?.append('image', upoadedImg);
        }

        console.log("Sending to backend - Gender:", selectedGender?.value, "Languages:", selectedLanguages, "Industry:", selectedIndustry, "Interests:", selectedInterests);

        setLoading(true);
        await post('', data)
            .then(response => {
                if (response?.result) {
                    fetchUserData();
                    alert('Profile updated successfully!');
                }
            })
            .catch(err => {
                console.log("there is an error uploading onboading Data => ", err);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            imageUrlUplad(file);
            const imageUrl = URL.createObjectURL(file);
            setProfileImage(imageUrl);
        }
    };

    const isMinimumSelected = selectedInterests?.length >= 5;
    const isMaximumSelected = selectedInterests?.length >= 7;

    return (
        <>
            <div className="p-4 border-b border-[#E1E4EA] relative">
                <Link to={'/setting'} className='absolute top-[23px] left-[20px] z-10'>
                    <RiArrowLeftLine className='w-[24px]  h-[24px]' />
                </Link>
                <h1 className='fs_18 mb-0 text-center britti relative top-[3px]'>Edit Profile</h1>
            </div>
            <div className='p-4 main_body'>
                <div className=' flex flex-col items-center justify-evenly h-100 px-[15px]'>
                    <div className=' relative p-2'>
                        <img src={profileImage ?? userData?.image} className='h-[120px] w-[120px] bg-[#ACCBFF] rounded-full object-cover object-top' alt="" onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = Avatar; }} />
                    </div>
                    <div>
                        <h1 className='britti_semibold fs_24 mt-3 text-center'>Profile Photo</h1>
                        <h2 className='txt_grey max-w-[234px] fs_16 mt-2 text-center britti_light'>You can use your LinkedIn photo or
                            upload a new one.</h2>
                        {/* <label className='transparent_btn px-5 mx-auto w-min mt-4 cursor-pointer'>
                            {loading ? <><Spinner animation="border" variant="light" /></> : <>Upload</>}
                            <input
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={handleImageUpload}
                            />
                        </label> */}
                    </div>
                </div>
                <div className='mt-4'>
                    <label htmlFor="" className='mb-2 fs_14 text-[#0E121B] britti'>Full Name</label>
                    <div className='customInput '>
                        <input type="text" value={fullname} placeholder='Your full name' disabled readOnly={true} name="" id="" />
                    </div>
                </div>
                <div className='mt-2'>
                    <label htmlFor="" className='fs_14 text-[#0E121B] britti mb-2'>Short Bio</label>
                    <div className='customInput min-h-[95px]'>
                        <textarea className='' value={bio} placeholder='A short bio about yourself' onChange={(e) => setBio(e.target.value)} name="" id="" >
                        </textarea>
                    </div>
                </div>

                <div className='mt-2'>
                    <label className='mb-[3px]' htmlFor="">Gender</label>
                    <div className=''>
                        <CustomSelect
                            data={genderOptions}
                            selectedItem={selectedGender}
                            onSelectionChange={handleGenderChange}
                            placeholder="Select Gender"
                            searchPlaceholder="Search..."
                            displayKey="name"
                            searchKey="name"
                            showIcon={false}
                            maxHeight="250px"
                            emptyMessage="No options found"
                            className="w-full"
                        />
                    </div>
                </div>

                <div className='mt-2'>
                    <label htmlFor="" className='fs_14 text-[#0E121B] britti mb-2'>Your Title / Position</label>
                    <div className='customInput'>
                        <input
                            type="text"
                            placeholder='e.g., "Software Engineer"'
                            onChange={(e) => setTitle(e.target.value)}
                            value={title}
                            name=""
                            id=""
                        />
                    </div>
                </div>

                <div className='mt-2'>
                    <label htmlFor="" className='fs_14 text-[#0E121B] britti mb-2'>Your Company / Organization</label>
                    <div className='customInput'>
                        <input
                            type="text"
                            placeholder='e.g., "Tech Company Inc."'
                            onChange={(e) => setCompany(e.target.value)}
                            value={company}
                            name=""
                            id=""
                        />
                    </div>
                </div>

                <div className='mt-2'>
                    <label className='mb-[3px] mt-[2px]' htmlFor="">Industry</label>
                    <div className=''>
                        <CustomSelect
                            data={industries}
                            selectedItem={selectedIndustry}
                            onSelectionChange={handleIndustryChange}
                            placeholder="Select Industry"
                            searchPlaceholder="Search industries..."
                            displayKey="name"
                            searchKey="name"
                            iconKey="flag"
                            showIcon={true}
                            maxHeight="300px"
                            emptyMessage="No industries found"
                            className="w-full"
                        />
                    </div>
                </div>

                <div className='mt-2'>
                    <label className='mb-[3px]' htmlFor="">Select languages you speak</label>
                    <div className=''>
                        <CustomMultiSelect
                            data={languages || []}
                            selectedItems={selectedLanguages}
                            onSelectionChange={handleLanguageChange}
                            placeholder="Add Languages..."
                            searchPlaceholder="Search languages..."
                            displayKey="name"
                            searchKey="name"
                            iconKey="flag"
                            showIcon={true}
                            showSelectedTags={true}
                            multiSelect={true}
                            maxHeight="300px"
                            emptyMessage="No languages found"
                            className="w-full"
                        />
                    </div>
                </div>

                <div className='mt-3'>
                    <label htmlFor="" className='fs_14 text-[#0E121B] britti mb-2'>
                        Interests 
                    </label>

                    <div className='w-full interestsGroup'>
                        {sortedInterestsList?.map((data, index) => (
                            <div className="interestItem" key={index}>
                                <div className={selectedInterests?.includes(data?.name) ? "interest" : "flex items-center justify-center h-100 px-[12px] border-1 border-transparent"}>
                                    {data?.name}
                                </div>
                                <input
                                    type="checkbox"
                                    checked={selectedInterests?.includes(data?.name)}
                                    onChange={(e) => handleCheckboxChange(e, data?.name)}
                                    disabled={loading || (selectedInterests?.length >= 7 && !selectedInterests?.includes(data?.name))}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                {selectedInterests?.length < 5 && (
                    <p className='text-red-500 fs_12 mb-2'>Please select at least 5 interests</p>
                )}
                <button
                    onClick={() => UpdateProfile()}
                    disabled={loading || !isMinimumSelected}
                    className={`primary_btn w-full rounded-xl mt-4 ${(!isMinimumSelected) ? 'opacity-50' : ''}`}
                >
                    {loading ? <><Spinner size='sm' animation="border" variant="light" /></> : "Save Changes"}
                </button>
            </div>
        </>
    )
}

export default Profile